//MAIN PAGES
export const HOME_PAGE = '/';

//MANAGEMENT PAGES
export const MANAGEMENT = '/admin/management';

//USER PAGES
export const MANAGEMENT_USER_CREATE = MANAGEMENT + '/user';

//ORGANIZATION PAGES
export const MANAGEMENT_ORGANIZATION_DETAILS = MANAGEMENT + '/organization/';

//PLAN PAGES
export const PLANS = '/plans/manage';

//LOCATION PAGES
export const LOCATION_PAGE = '/admin/location';

//ASSIGMENT PAGES
export const ASSIGNMENT_PAGE = '/plans/assign';

export const SIMULATION_PAGE = '/plans/simulation';

export const RESOURCE_PLANNING_PAGE = '/plans/resource-planning';

export const CampaignManage = '/plans/campaign-management';

//REPORTING PAGES
export const REPORTING_PAGE = '/reports';

export const TAG_MANAGEMENT = '/admin/tag-management';

export const METADATA_IMPORT = '/admin/metadata-import';

export const AMDR_IMPORT = '/admin/amdr-import';

export const AMDR_REPORT = '/amdr/report';

export const DATA_PROCESSING_PROGRESS = '/admin/kafka-messaging';
export const GROUP_MANAGEMENT = '/groupmanagement';
export const INSTANCE_CONFIGURATION = '/instance-configuration';

export const DATA_EXTRACTS = '/admin/data-extracts';
